<template>
    <div id="mail">
        <div class="banner">
            <div class="hd">

                <div class="h pubw">
                    <span>代購計算</span>
                </div>
              <div class="details-form">

                <div class="details-linename"><span style="font-weight: bold;" >商品鏈接(如多於一條鏈接可以另外於WHATSAPP發送給我們)</span></div>
                <div class="details-linename" >
                <el-input v-model="url" placeholder="請输入商品鏈接,如www.****.com" size="mini" @input="handleQuery"></el-input>
                </div>
                <div class="details-linename"><span style="font-weight: bold;" >貨款</span></div>
                <div class="details-linename">
                  <el-input  v-model="mustZ" type="number"  placeholder="請输入貨款数额" size="mini" @input="handleQuery" >
                    <template slot="append">JPY 日圓</template></el-input>
                </div>
                <div class="details-linename"><span style="font-weight: bold;">日本國內運費（如有）</span></div>
                <div class="details-linename">
                  <el-input v-model="unnecessaryZ" type="number"  placeholder="請输入日本國內運費" size="mini" @input="handleQuery">
                    <template slot="append" >JPY 日圓</template></el-input>
                </div>
                <div class="details-linename"><span style="font-weight: bold;">自選額外收費服務</span></div>
                <div class="details-linename">
                  <el-checkbox-group  v-model="checkListA"  @input="handleQuery">
                    <el-checkbox  text-color="#575D7E"  v-for="item in itemList" :key="item.id" :label="item.id" >
                      <label > {{ item.name }}</label>
                      <label class="ey" > {{ item.money }}</label>
                    </el-checkbox><br> <br>


                  </el-checkbox-group>
                </div>
                <div class="details-linename"><span style="font-weight: bold;" >優惠匯率及其他優惠</span></div>
                <div class="details-linename">
                  <el-checkbox-group v-model="checkListV" @input="handleQuery">
                    <el-checkbox  text-color="#575D7E"  v-for="item in itemListV" :key="item.id" :label="item.id" >
                      <label > {{ item.name }}</label>
                      <label class="ey" > {{ item.money }}</label>
                    </el-checkbox><br> <br>

                  </el-checkbox-group>
                </div>
<!--                <br> <br>-->
<!--                <div class="details-center"><span  >實際匯率約&nbsp;&nbsp;&nbsp;</span><span class="HC">{{this.exchangeRate}}</span></div>-->
<!--                <br> <br>-->
<!--                <div class="details-center"><span   >手續費&nbsp;&nbsp;&nbsp;</span><span class="HC">{{this.handling}}</span></div>-->
<!--                <br> <br>-->
<!--                <div class="details-center"><span   >所需費用（未包括國際運費）&nbsp;&nbsp;&nbsp;</span><span class="HK" >HK$ </span><span class="HKD">{{this.money}}</span></div>-->

                <br> <br>
                <div class="details-center">
                  <el-table :data="tableData" border    :show-header="false">
                    <el-table-column prop="name" label="Column 1">
                      <template slot-scope="scope">
                        <div class="centered-text">{{ scope.row.name }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="money" label="Column 2" >
                      <template slot-scope="scope">
                        <div class="centered-text" :style="getCellStyle(scope.row.name)">{{ scope.row.money }}</div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <br>
                  <el-link href="https://www.kyowagroup.com.hk/japan-hongkong-shipping" target="_blank" >請按此查看國際運費</el-link>

                </div>
                <br> <br>


                <div class="bottom">

                  <optionsButtonD  class="fill-button" title="按此複製以上内容並立即WhatsApp 查詢" :callback="JapaneseNow" />
                </div>
              </div>


            </div>

            </div>


        </div>


</template>

<script>
    // 引入组件
    import optionsButtonD from '@/components/optionButtonD'
import Weight from "@/components/Weight.vue"
import Budget from "@/views/Mail/Budget/Budget.vue"

export default {
    name:'Purchasing',
    components:{
      optionsButtonD,
        Weight,
        Budget
    },
    data(){
        return {
          url:null,
          text:null,
          must:0.0,
          unnecessary:0.0,
          handling:0.0,
          mustZ:null,
          unnecessaryZ:null,
          checkListA: [],
          checkListV: [],
          tableData: [],
          money:0,
          exchangeRate:0.0546,


          itemList: [],
          itemListV: [],


          loginRuleForm:{
          },
          checked: true,
            //   寄件菜单

            // 当前的选择的物品类型
            curType:'1',
            // 当前最大重量
            maxWeight:0,
        }
    },
    created() {
        // this.$router.push("/purchasing/type1")
      this.getList();
    },
    methods: {
      getCellStyle(value) {
        if (value === '所需費用（未包括國際運費）') {
          return 'color: red;';
        } else {
          return 'color: black;';
        }
      },
      async getList(){
        let res = await this.$http.get(`/business/preferential/list` )
        this.itemList = res.data.data;
        let resv = await this.$http.get(`/business/pconcessions/list` )
        this.itemListV = resv.data.data;
        this.handleQuery();
      },
      async handleQuery() {
        // this.$refs.loginRuleForm.validate(async valid =>{
        if (this.mustZ == null){
          this.must = 0.0
        }else {
          this.must = this.mustZ
        }
        if (this.unnecessaryZ == null){
          this.unnecessary = 0.0
        }else {
          this.unnecessary = this.unnecessaryZ
        }

        let ss = this.url
        let res = await this.$http.post(`app/login/purchasing?must=${this.must}&unnecessary=${this.unnecessary}
        &checkListA=${this.checkListA}&checkListV=${this.checkListV}&urlS=`+ encodeURIComponent(ss))
        console.log(encodeURIComponent(ss), 'url')
        this.money = res.data.money.toFixed(0);
        this.handling = res.data.handling.toFixed(0);
        this.text = res.data.text;
        this.exchangeRate = res.data.exchangeRate;
        this.tableData = res.data.tableList;


        // })

      },
      JapaneseNow(){

        if (this.url!=null && this.mustZ != null){
          window.open("https://api.whatsapp.com/send?phone=+8108076702875&text="+this.text)
        }else {
          this.$message.error("請先填寫商品鏈接，貨款等必要信息")
        }

      },
        // 监听点击寄件类型
        async handleMailTypeClick(type){
            if(type == this.curType)return;
            if(type == '4'){
                        const confirmResult = await this.$confirm('因國內外航機班次及價格變動非常迅速，暫時只能通過電郵報價。聯繫我們: Hello@goods2go.io', '提示',
                    {
                        confirmButtonText: '確認',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                ).catch(err => err)

                return
            }
            if(type == "1" || this.curType == "1"){
                const confirmResult = await this.$confirm('信件不能和物品混合，此操作將過濾之前選擇的箱子，是否繼續？', '提示',
                    {
                        confirmButtonText: '確認',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                ).catch(err => err)
                if(confirmResult !== 'confirm'){
                    return this.$message.info('已取消')
                }
            }
            this.$store.commit("CHANGEBOXTYPE",'0'+type)
            this.curType = type
            this.$router.push(`/mail/type${type}`)
        },
        // 获取最大重量
        getMaxWeight(value){
            this.maxWeight = value
        }
    },

}
</script>

<style scoped lang="less">

    .below{
      /* 路径 1803 */
      width: 23px;
      height: 13px;
      top: 245px;
      left: 947px;
      background-color: #F74042;
    }


    .grid-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      min-height: 36px;
      text-align: center;
      margin: 0.5rem;
      cursor: pointer;
    }

    #mail{

      /deep/ .centered-text {
        text-align: center;
      }


        .banner{

            .hd{
              display: flex;
              flex-direction: row; /* 默认水平排列 */
              flex-wrap: wrap; /* 自动换行 */


                padding-top:100px;
                .h{

                    font-size: 35px;
                    font-family: PingFang HK;
                    margin: 0 auto;
                    text-align:center;
                    span{
                        display: inline-block;
                        line-height:50px;
                        width: 600px;
                    }
                }
             .details-form {
                width: 40%;
                margin: 0 auto;
                background-color: #FFFFFF;
                padding: 1.2rem;
                margin-top: 1.2rem;
                .details-linename {
                  color: #333333;
                  text-align: left;
                  font-weight: 500;
                  padding-bottom:20px;

                  /deep/ .el-checkbox {
                    width: 100% ;
                    margin-bottom: 10px;
                    .el-checkbox__label {
                      display: inline-flex;
                      justify-content: space-between;
                      width: 97%;
                    }
                  }
                  /deep/ .custom-input ::placeholder {
                    font-size: 14px; /* 设置占位符字体大小 */
                  }
                  /deep/ .el-input__inner {
                    background-color: #F5F5F5;

                    /deep/ .el-input-group__append{
                      background-color: #F5F5F5;
                      font-size: 12px;
                    }
                  }

                  .details-sp {
                    text-align: right;

                  }
                }

                .details-center{
                  color: #333333;
                  text-align: center;
                  font-weight: 500;
                  padding-bottom:10px;

                  /deep/ .el-link--inner{

                    text-align: center;
                    font-weight: bold;
                    display: inline-block;
                    span{
                      font-weight: bold;
                      display: inline-block;
                      line-height:50px;
                      width: 600px;
                    }
                  }
                  .HC{
                    font-family: Roboto;
                    color: #333333;
                    text-decoration: none;
                    font-size: 20px;
                  }
                  .HK{
                    /* HK$ 780 */
                    width: 95px;
                    height: 37px;
                    top: 1150px;
                    left: 1265px;
                    font-family: Roboto;
                    color: #F74042;
                    font-weight: 700;
                    font-style: normal;
                    text-decoration: none;
                    text-align: right;
                    /* HK$  */
                    font-size: 20px;
                  }
                  .HKD{
                    /* HK$ 780 */
                    width: 95px;
                    height: 37px;
                    top: 1150px;
                    left: 1265px;
                    font-family: Roboto;
                    color: #F74042;
                    font-weight: 700;
                    font-size: 30px;
                    font-style: normal;
                    text-decoration: none;
                    text-align: right;
                    /* HK$  */
                  }
                }
                .bottom{
                  text-align: center;
                  margin-top: 20px;
                }
              }

            }
            .bd{
                background-color: #fff;
            }
        }
    }

  /* 最大宽度768px 手机 */
@media screen and (max-width: 768px){
  #mail{

    /deep/ .centered-text {
      text-align: center;
    }

    .banner{

      .hd{

        display: flex;
        flex-direction: row; /* 默认水平排列 */
        flex-wrap: wrap; /* 自动换行 */

        padding-top:100px;
        .h{


          font-size: 35px;
          font-family: PingFang HK;
          margin: 0 auto;
          text-align:center;
          span{
            display: inline-block;
            line-height:25px;
            width: 300px;
          }
        }
        .details-form {

          width: 100%;
          margin: 0 auto;
          background-color: #FFFFFF;
          padding: 1.2rem;
          margin-top: 1.2rem;
          .details-linename {
            color: #333333; //记得改回来
            //color: #F74042;
            text-align: left;
            font-weight: 500;
            padding-bottom:20px;

            /deep/ .el-checkbox {
              width: 100% ;
              margin-bottom: 10px;
              .el-checkbox__label {
                display: inline-flex;
                justify-content: space-between;
                width: 97%;
              }
            }
            /deep/ .custom-input ::placeholder {
              font-size: 3px; /* 设置占位符字体大小 */
            }
            /deep/ .el-input__inner {
              background-color: #F5F5F5;

              /deep/ .el-input-group__append{
                background-color: #F5F5F5;
                font-size: 3px;
              }
            }

            .details-sp {
              text-align: right;

            }
          }

          .details-center{
            color: #333333;
            text-align: center;
            font-weight: 500;
            padding-bottom:10px;

            /deep/ .el-link--inner{
              text-align: center;
              font-weight: bold;
              display: inline-block;
              span{
                font-weight: bold;
                display: inline-block;
                line-height:50px;
                width: 600px;
              }
            }
            .HC{
              font-family: Roboto;
              color: #333333;
              text-decoration: none;
              font-size: 20px;
            }
            .HK{
              /* HK$ 780 */
              width: 95px;
              height: 37px;
              top: 1150px;
              left: 1265px;
              font-family: Roboto;
              color: #F74042;
              font-weight: 700;
              font-style: normal;
              text-decoration: none;
              text-align: right;
              /* HK$  */
              font-size: 20px;
            }
            .HKD{
              /* HK$ 780 */
              width: 95px;
              height: 37px;
              top: 1150px;
              left: 1265px;
              font-family: Roboto;
              color: #F74042;
              font-weight: 700;
              font-size: 30px;
              font-style: normal;
              text-decoration: none;
              text-align: right;
              /* HK$  */
            }
          }
          .bottom{
            text-align: center;

            position: relative;
            //width: 700px; /* 或者您希望的DIV宽度 */
            height: 65px; /* 或者您希望的DIV高度 */
          }


          .fill-button {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
        }

      }
      .bd{
        background-color: #fff;
      }
    }
  }
}
</style>
